import { render, staticRenderFns } from "./ConfirmOrder.vue?vue&type=template&id=0cf9d9b0&scoped=true&"
import script from "./ConfirmOrder.vue?vue&type=script&lang=ts&"
export * from "./ConfirmOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmOrder.vue?vue&type=style&index=0&id=0cf9d9b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf9d9b0",
  null
  
)

export default component.exports